import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-get-enrollment',
  templateUrl: './get-enrollment.component.html',
  styleUrls: ['./get-enrollment.component.scss']
})
export class GetEnrollmentComponent implements OnInit {

  constructor(private service: ApiService, private config: ApiConfiguration, private toast: ToastClientService, private route:Router) { }
  public enrollments;
  ngOnInit() {
    this.service.get(this.config.getVisitEnrollment)
    .subscribe((res:any)=>{
      this.enrollments = res.data.pending_enrollments;
      console.log(res.data.pending_enrollments)
    })

  }
  approve(id){
    let payload = {
      program_id: 1,
      id: id,
      approve_reject: 1

    }
    this.service.postWithFormData(this.config.approveRejectEnroll, payload)
    .subscribe((res:any)=>{
      if(res.status == 200){
        this.toast.Success("Approved");
        this.ngOnInit()
      }else{
        console.log(res)
      }
    })
  }

  reject(id){
    let payload = {
      program_id: 1,
      id: id,
      approve_reject: 0

    }
    this.service.postWithFormData(this.config.approveRejectEnroll, payload)
    .subscribe((res:any)=>{
      if(res.status == 200){
        this.toast.Error("Rejected");
        this.ngOnInit()
      }else{
        console.log(res)
      }
    })

  }
  view(id){
    this.route.navigate(['/hubAdmin/view-enroll'], { queryParams: { enrollId: id} });
  }

}
